import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdEdit } from "react-icons/md";
import moment from "moment";
import {
    ModalContainer,
    ModalHeader,
    ModalContent,
    ScrollableContent,
    ModalSection,
    ModalRow,
    ModalRowLabel,
    ModalRowValue,
    ModalSectionTitle,
    ActionSection,
    SideCancelBtn,
    SubmitBtn,
} from "../../Styles/InputStyles";
import { capitalizeFirstLetter, getCategoryIcon, getFoodCategoryLabel, getFoodUnitLabel } from "../../../helpers";
import { FaBuilding, FaBox, FaMoneyBillWave, FaCalendarAlt, FaUser } from "react-icons/fa";
import ModalProfileHeader from "../../Common/ModalProfileHeader";
import ModalProfileHeaderWithoutImage from "../../Common/ModalProfileHeaderWithoutImage";

const ViewStockTransferDetails = ({
    setShowTransferDetails,
    selectedData,
}) => {
    const onClose = () => {
        setShowTransferDetails(false);
    };

    const entries = selectedData?.entries || [];
    const totalItems = entries.reduce((sum, entry) => sum + entry.quantity, 0);
    const transferDate = selectedData?.transferDate || selectedData?.createdAt;

    // Calculate total amount from entries
    // const totalAmount = entries.reduce((sum, entry) => sum + (entry.assignedPrice || 0), 0);
    const totalAmount = selectedData?.totalAmount

    return (
        <ModalContainer>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Stock Transfer Details</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ModalProfileHeaderWithoutImage
                title="Stock Transfer"
                name={capitalizeFirstLetter(selectedData?.kitchenName || "Unknown Kitchen")}
                subtitle={`Transfer #${selectedData?.transferId || 'N/A'}`}
                amount={totalAmount || 0}
                // image={selectedData?.profilePicture}
                onClose={onClose}
            />

            <ModalContent>
                <ScrollableContent>
                    <Wrapper>
                        {/* Items Section */}
                        <BtnWrapper>
                            <ModalSectionTitle>Transferred Items</ModalSectionTitle>
                            <span className="text-xs text-gray-400">
                                {entries.length} {entries.length > 1 ? 'items' : 'item'}
                            </span>
                        </BtnWrapper>

                        <ModalSection>
                            {entries.length > 0 ? (
                                <div className="space-y-3">
                                    {entries.map((entry, index) => {
                                        const totalPrice = entry.assignedPrice || 0;
                                        return (
                                            <ItemCard key={entry.id || index}>
                                                <div className="flex items-start gap-4">
                                                    {/* Item Details */}
                                                    <div className="flex-1 min-w-0">
                                                        <ItemName>
                                                            {capitalizeFirstLetter(entry.itemName || "Unknown Item")}
                                                        </ItemName>

                                                        <div className="flex items-center gap-2 mt-1">
                                                            <CategoryText>
                                                                {getFoodCategoryLabel(entry.categoryId)}
                                                            </CategoryText>

                                                            <Dot />

                                                            <QuantityText>
                                                                {entry.quantity} {getFoodUnitLabel(entry.unitType)}
                                                            </QuantityText>
                                                        </div>
                                                    </div>

                                                    {/* Amount */}
                                                    <Amount className="ml-auto">
                                                        ₹{Number(totalPrice || 0).toLocaleString('en-IN')}
                                                    </Amount>
                                                </div>
                                            </ItemCard>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center py-4 text-gray-500">No items found</div>
                            )}
                        </ModalSection>

                    </Wrapper>
                </ScrollableContent>
            </ModalContent>
        </ModalContainer>
    );
};

// Styled Components
const Wrapper = tw.div`grid gap-2 my-0`;

const BtnWrapper = tw.div`w-full flex items-center justify-between`;

const ItemCard = tw.div`
    w-full
    px-6
    py-4
    rounded-lg
    bg-white
    border
    border-gray-200
    transition-all
    duration-200
    hover:border-gray-300
    hover:shadow-sm
`;

const ItemName = tw.div`
    text-sm
    font-semibold
    text-gray-800
    truncate
`;

const CategoryText = tw.span`
    text-xs
    text-gray-400
`;

const QuantityText = tw.span`
    text-xs
    font-medium
    text-gray-500
`;

const Dot = tw.span`
    w-1
    h-1
    rounded-full
    bg-gray-300
`;

const Amount = tw.div`
    mt-0.5
    text-sm
    font-semibold
    text-gray-900
    tabular-nums
`;

export default ViewStockTransferDetails;